import { render, staticRenderFns } from "./UISearchProfile.vue?vue&type=template&id=052df200"
import script from "./UISearchProfile.vue?vue&type=script&lang=js"
export * from "./UISearchProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default})
